<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    ref="input"
    rounded
    outlined
    single-line
    dense
    label="Pesquisar"
    autofocus
    clearable
    hide-details
    prepend-inner-icon="mdi-magnify"
    :style="style"
    @focus="onFocus"
  >
    <template #append v-if="showType">
      <v-menu
        offset-y
        v-model="menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            v-on="on"
            color="primary"
            small
            clickable
            elevation="4"
            @click="menu = true"
          >
            {{ selectedSearchType }}
          </v-chip>
        </template>
        <v-list>
          <v-list-item
            v-for="option in searchOptions"
            :key="option.value"
            @click="selectSearchType(option)"
          >
            <v-list-item-title>{{ option.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>

export default {
  props: {
    select: {
      type: Boolean,
      default: false
    },

    width: {
      type: String,
      default: '300px'
    },

    showType: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      menu: false,
      searchOptions: [
        { text: 'Contém', value: 'contem' },
        { text: 'Começa por', value: 'comeca_por' },
      ],
      selectedSearchType: 'Contém',
      selectedOption: null,
      inputWidth: null,
    }
  },

  computed: {
    style() {
      return {
        maxWidth: this.inputWidth,
      }
    }
  },

  mounted() {
    this.inputWidth = this.width;
    if (this.showType && this.width === '300px') {
      this.inputWidth = "350px";
    }

    const searchOptions = this.searchOptions.find(option => option.value === this.$storage.get('SearchType'));
    if (searchOptions) {
      this.selectedOption = searchOptions;
      this.selectedSearchType = searchOptions.text;
    } else {
      this.selectedSearchType = this.searchOptions[0].text;
    }

    this.selectedOption = this.searchOptions[0];
    this.$emit('change:type', this.selectedOption.value);
  },

  methods: {
    onFocus(event) {
      if (this.select) {
        setTimeout(function () {
          event.target.select();
        }, 0);
      }
    },

    focus() {
      this.$refs.input.focus();
    },

    blur() {
      this.$refs.input.blur();
    },

    selectSearchType(option) {
      this.selectedOption = option;
      this.selectedSearchType = option.text;
      this.menu = false;

      this.$storage.set('SearchType', option.value);

      setTimeout(() => {
        this.$refs.input.focus();
      }, 100);
      this.$emit('change:type', option.value);
    },

  },
};
</script>

<style scoped>
</style>
